import { nanoid } from "@reduxjs/toolkit";
import { ChangeEventHandler, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/Modal";
import Option from "../../components/Option";
import UnitForm from "../../components/admin/UnitForm";
import { FormInput } from "../../components/custom/components";
import AdminTable, {
  Tbody,
  Thead,
} from "../../components/custom/components/AdminTable";
import AdminLayout from "../../components/custom/layouts/AdminLayout";
import { ToastTypes, useToast } from "../../components/toast/ToastProvider";
import { FormType, FormTypeList } from "../../config";
import {
  SiteType,
  fetchUsersSite,
} from "../../redux/actions/siteActions";
import {
  BuildingType,
  fetchBuilding,
} from "../../redux/actions/buildingActions";
import {
  FloorType,
  fetchFloor,
} from "../../redux/actions/floorActions";
import { PortfolioType } from "../../redux/actions/portfolioActions";
import { AppDispatch, StoreState } from "../../redux/store";
import DeleteConfirmationForm from "../../components/admin/DeleteConfirmationForm";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { AuthAdminType } from "../../redux/actions/authAdminActions";
import { AdminLog } from "../../config/common";
import { deleteUnit, fetchUnit, UnitType } from "../../redux/actions/unitActions";

type HandleDelete = (value: UnitType) => void;

const UnitManagement = () => {
  const toast = useToast();
  const dispatch = useDispatch<AppDispatch>();
  const pageName = useLocation()
  const navigate = useNavigate();
  const authAdmin = useSelector<StoreState, AuthAdminType | null>(
    (state) => state.authAdmin
  );
  const adminAuthendicated =
  typeof authAdmin?.["auth-token"] === "string" &&
  authAdmin?.["auth-token"] !== undefined &&
  authAdmin?.["auth-token"] !== "";  
  const portfolioList = useSelector<StoreState, Array<PortfolioType>>(
    (state) => state.portfolio
  );  
  // const filteredPortfolio = portfolioList.filter((a) => a.businessmodel !== 1);

  const UnitList = useSelector<StoreState, Array<UnitType>>(
    (state) => state.space
  );
  const siteList = useSelector<StoreState, Array<SiteType>>(
    (state) => state.site
  );
  const BuildingList = useSelector<StoreState, Array<BuildingType>>(
    (state) => state.building
  );
  const FloorList = useSelector<StoreState, Array<FloorType>>(
    (state) => state.floor
  );

  const [portfolioId, setportfolioId] = useState<string>("");
  const [portfolioIdError, setportfolioIdError] = useState<string>("");

  const [showForm, setShowForm] = useState<boolean>(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);
  const [formType, setFormType] = useState<FormType>(FormTypeList.ADD);
  const [editData, setEditData] = useState<UnitType>();
  const [deleteData, setDeleteData] = useState<UnitType>();
  const [showViewForm, setShowViewForm] = useState<boolean>(false);
  const [id, setId] = useState<number>();

  const [searchQuery, setSearchQuery] = useSearchParams();
  const searchTerm = searchQuery.get("search") || "";

  const searchHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    if (!portfolioId) {
      toast("Porfolio required", ToastTypes.ERROR);
      setSearchQuery({ search: "" });
      return;
    }
    setSearchQuery({ search: e.target.value });
  };

  const searchFloorHandler = (item: any, searchTerm: string) => {
    return searchTerm !== ""
      ? new RegExp(`^${searchTerm}|${searchTerm}`, "gi").test(
          item[1]["text"] + " " + item[2]["text"] + " " + item[3]["text"] + item[4]["text"] + item[5]["text"]
        )
      : true || [];
  };

  const handlePfid: ChangeEventHandler<HTMLInputElement> = (e) => {
    setportfolioId(e.target.value);
    setportfolioIdError("");
  };

  const getTableData = () => {
    if (FloorList === undefined) {
      return { tbody: [], thead: [] };
    }
    var tableHead: Thead[] = [
      { id: "S.No", children: "S.No", text: "S.No" },
      { id: "Center Name", children: "Center Name", text: "Center Name" },
      { id: "Building Name", children: "Building Name", text: "Building Name" },
      { id: "Floor Name", children: "Floor Name", text: "Floor Name" },
      { id: "Unit Name", children: "Unit Name", text: "Unit Name" },
      { id: "Unit No", children: "Unit No", text: "Unit No" },
      { id: "Action", children: "Action", text: "Action" },
    ];
    var tableBody: Tbody[][] = [];
    var tableBodyFiltered: Tbody[][] = [];

    if (portfolioId) {
      UnitList.forEach((item, i) => {
        let index = siteList.findIndex((c, i) => {
          return c.id === item.centerid;
        });
        var cname = siteList[index]?.name;
        let bindex = BuildingList.findIndex((c, i) => {
          return c.id === item.buildingid;
        });
        var buildingname = BuildingList[bindex]?.buildingname;
        let findex = FloorList.findIndex((c, i) => {
          return c.id === item.floorid;
        });
        var fname = FloorList[findex]?.floorname;

        var tBody: Tbody[] = [];
        tBody.push(
          {
            id: nanoid(),
            theadId: "S.No",
            children: i + 1,
            text: (i + 1)?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Center Name",
            children: cname,
            text: cname,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Building Name",
            children: buildingname,
            text: buildingname,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Floor Name",
            children: fname,
            text: fname,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Unit Name",
            children: item.unitname,
            text: item.unitname,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Unit No",
            children: item.unitno,
            text: item.unitno,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Action",
            children: "action",
            className: "d-none",
            text: item.id?.toString(),
          }
        );
        tableBody.push(tBody);
      });
      if (searchTerm?.length > 0) {
        tableBodyFiltered = tableBody.filter((item) =>
          searchFloorHandler(item, searchTerm)
        );
      } else {
        tableBodyFiltered = tableBody;
      }

      if (UnitList !== undefined) {
        return { tbody: tableBodyFiltered, thead: tableHead };
      }
    }
    return { tbody: tableBody, thead: tableHead };
  };

  const handleAdd = () => {
    if (!portfolioId) toast("Portfolio required", ToastTypes.ERROR);
    else {
      setShowForm(true)
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Create',
          event: `${pageName.pathname.replace("\\", " ")} page | Create Unit Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleView = () => {
    setFormType(FormTypeList.VIEW);
    if (id !== undefined) {
      var obj = UnitList.find((c) => c.id === id);
      var centerObj = siteList.find((d)=>d.id===obj?.centerid)
      var buildingObj = BuildingList.find((e)=>e.id===obj?.buildingid)
      var floorObj = FloorList.find((f)=>f.id===obj?.floorid)
      setShowForm(true);
      setEditData(obj);
      setShowViewForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'View',
          event: `${pageName.pathname.replace("\\", " ")} page | Building - ${buildingObj?.buildingname}, Floor - ${floorObj?.floorname}, Unit - ${obj?.unitno} Viewed | View Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDeleteConfirmation = () => {
    setFormType(FormTypeList.DELETE);
    if (id !== undefined) {
      var obj = UnitList.find((c) => c.id === id);
      setShowDeleteConfirmation(true);
      setDeleteData(obj);
    }
  };

  const handleEdit = () => {
    setFormType(FormTypeList.EDIT);
    if (id !== undefined) {
      var obj = UnitList.find((c) => c.id === id);
      setEditData(obj);
      setShowForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Edit',
          event: `${pageName.pathname.replace("\\", " ")} page | Unit - ${obj?.unitno}  | Edit Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDelete: HandleDelete = (value) => {
    if (value.id !== undefined) {
      dispatch(deleteUnit(value.id, portfolioId))
        .then((text) => {
          toast(text, ToastTypes.SUCCESS);
          var obj = UnitList.find((c) => c.id === id);
          if(adminAuthendicated){
            const logProps1 = {
              action: 'Delete',
              event: `${pageName.pathname.replace("\\", " ")} page | Unit - ${obj?.unitno} | Delete Clicked`
            };
            AdminLog(logProps1)
          }
          handleFormClose();
        })
        .catch((text) => {});
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setFormType(FormTypeList.ADD);
    setEditData(undefined);
    setId(undefined);
    setShowViewForm(false);
    setShowDeleteConfirmation(false);
  };

  useEffect(() => {
    if (id !== undefined && formType === FormTypeList.VIEW) handleView();
    else if (id !== undefined && formType === FormTypeList.EDIT) handleEdit();
    else if (id !== undefined && formType === FormTypeList.DELETE)
      handleDeleteConfirmation();
  }, [id, formType]);

    useEffect(()=>{
     navigate("/admin/unit_entry");
  },[])

  useEffect(() => {
    if (portfolioId) {
      dispatch(fetchUnit(portfolioId));
      dispatch(fetchUsersSite());
      dispatch(fetchBuilding(portfolioId));
      dispatch(fetchFloor(portfolioId));
    }
  }, [portfolioId]);

  useEffect(()=>{
    if(adminAuthendicated){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName.pathname.replace("\\", " ")} page | Visited `
    };
    AdminLog(logProps1)
  }
  },[])

  return (
    <>
      <Modal
        headerText={formType + " Unit"}
        visible={showForm}
        onClose={handleFormClose}
        size="xl"
        centered
      >
        <UnitForm
          formType={formType}
          editData={editData}
          onSave={handleFormClose}
          showViewForm={showViewForm}
          pfId={portfolioId}
        />
      </Modal>
      <Modal
        headerText={formType + " Unit"}
        visible={showDeleteConfirmation}
        onClose={handleFormClose}
        size="lg"
        centered
      >
        <DeleteConfirmationForm
          deleteLabel={
            "Do you really want to delete the records with the Unit - " +
            deleteData?.unitno
          }
          onCancel={handleFormClose}
          onDelete={() => handleDelete(deleteData!)}
        />
      </Modal>
      <AdminLayout>
        <div className="row">
          <div className="col-6 hstack mt-4">
            <label htmlFor="">Portfolio :</label>
            <FormInput
              name="Portfolio"
              label=""
              labelClassName="required"
              value={portfolioId}
              onChange={handlePfid}
              placeholder="Portfolio"
              errorText={portfolioIdError}
              containerClass="w-50"
              disabled={showViewForm}
              type="select"
            >
              <option value="">Select</option>
              {portfolioList.map((a, i) => {
                return (
                  <Option value={a.id} key={i}>
                    {a.name}
                  </Option>
                );
              })}
            </FormInput>
          </div>
        </div>
        <AdminTable
          addBtnText="Create New Unit"
          onAdd={handleAdd}
          onEdit={handleEdit}
          onDelete={handleDeleteConfirmation}
          onView={handleView}
          search={
            portfolioId !== "" && portfolioId !== undefined
              ? searchHandler
              : undefined
          }
          pageTitle="Unit Management"
          path="/admin/unit_entry"
          // data={data}
          setId={setId}
          {...getTableData()}
        />
      </AdminLayout>
    </>
  );
};

export default UnitManagement;
